import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AppIcons } from '@/components/AppIcons'
import { BaseView, BaseText } from '@/components/base'
import { BlurModal } from '@/components/BlurModal'

interface ApyInfoProps {
  apyPercentage?: number
  /** Whether used on a colorful screen (for styling) */
  isFromColorfulScreen?: boolean
  /** Icon size */
  size?: number
  /** Icon color */
  color?: string
}

export const ApyInfo: React.FC<ApyInfoProps> = ({
  apyPercentage = 5.5,
  isFromColorfulScreen = false,
  size = 28,
  color,
}) => {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleInfoPress = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  // Icon style depending on screen type
  const iconColor =
    color || (isFromColorfulScreen ? 'rgba(255, 255, 255, 0.2)' : undefined)

  return (
    <>
      {/* APY Info Icon */}
      <button
        onClick={handleInfoPress}
        style={{
          border: 'none',
          borderRadius: isFromColorfulScreen ? '20px' : '0px',
          //   padding: is    FromColorfulScreen ? '8px 16px' : '8px',
          marginRight: '16px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: isFromColorfulScreen ? '8px' : '0px',
        }}
      >
        <AppIcons
          name="smallInfo"
          color="red"
          size={size}
          unthemedColor={iconColor}
          secondColor="white"
        />
      </button>

      {/* APY Info Blur Modal */}
      <BlurModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title={`${t('translation:transferIn.APY')} ${apyPercentage}%`}
        isFromColorfulScreen={isFromColorfulScreen}
      >
        <BaseView gap={24} py={16} style={{ paddingBottom: 26 }}>
          <BaseText
            fontSize={16}
            fontFamily="regular"
            style={{
              color: isFromColorfulScreen ? 'white' : '#AAAEB1',
              textAlign: 'center',
              lineHeight: '1.5',
            }}
          >
            {t('translation:transferIn.APYDescription')}
          </BaseText>

          <button
            onClick={handleCloseModal}
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)', // Semi-transparent white as in RN
              color: '#FFFFFF', // White text as in RN
              border: 'none',
              borderRadius: '16px',
              padding: '16px 32px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              width: '100%',
              margin: '0 auto',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.3)'
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'
            }}
            onFocus={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.3)'
            }}
            onBlur={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'
            }}
          >
            {t('form:actions.okay')}
          </button>
        </BaseView>
      </BlurModal>
    </>
  )
}
